export abstract class PagedQuery {
	pageSize = 25;
	page = 1;

	constructor(init?: Partial<PagedQuery>) {
		Object.assign(this, init);
	}
}
